import { ConfigurationFieldType } from '@ydistri/api-sdk';
import { setEntityListSectionStatus } from '../../../../../components/global/CategoryTree/categoryTreeSlice';
import { useAppDispatch } from '../../../../../store';
import { useCallback } from 'react';

export type EntityListSectionModifier = (
  calculationId: number,
  categoryId: number,
  fieldType: ConfigurationFieldType,
) => void;

/**
 * Hook to return functions to enable or disable the entity list section.
 */
export const useEntityListSectionModifier = (): EntityListSectionModifier[] => {
  const dispatch = useAppDispatch();

  const enableEntityListSection = useCallback(
    (calculationId: number, categoryId: number, fieldType: ConfigurationFieldType) => {
      dispatch(
        setEntityListSectionStatus({
          calculationId,
          categoryId,
          fieldType,
          disabled: false,
        }),
      );
    },
    [dispatch],
  );

  const disableEntityListSection = useCallback(
    (calculationId: number, categoryId: number, fieldType: ConfigurationFieldType) => {
      dispatch(
        setEntityListSectionStatus({
          calculationId,
          categoryId,
          fieldType,
          disabled: true,
        }),
      );
    },
    [dispatch],
  );

  return [enableEntityListSection, disableEntityListSection];
};
